import { TrackableItem, TrackableObjectType } from 'types/trackables';

import { useTrackableFiles } from '../../hooks/useTrackableFiles';

interface TrackableItemThumbnailProps {
  item: TrackableItem;
  trackableListId: string;
  objectType?: TrackableObjectType;
}

export function TrackableItemThumbnail({
  item,
  trackableListId,
  objectType,
}: TrackableItemThumbnailProps) {
  // Fetch only the first file with thumbnail
  const { data: filesData } = useTrackableFiles({
    params: {
      trackable_list_id: trackableListId,
      trackable_item_id: item.id,
      with_thumbnail: true,
      limit: 1,
      page: 1,
    },
    enabled: Boolean(trackableListId && item.id),
  });

  const firstFile = filesData?.data?.[0];
  const thumbnailUrl = firstFile?.thumbnail_url;

  // Determine the placeholder icon based on object type
  const placeholderIcon = objectType === 'face' ? '👤' : '📦';

  return (
    <div className="flex h-11 w-20 items-center justify-center overflow-hidden rounded-md border border-gray-200 bg-transparent dark:border-gray-700">
      {thumbnailUrl ? (
        <img
          src={thumbnailUrl}
          alt={`${item.name} thumbnail`}
          className="h-full w-full rounded-md object-cover"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center rounded-md bg-gray-100 dark:bg-gray-800">
          <span className="text-xs text-gray-400">{placeholderIcon}</span>
        </div>
      )}
    </div>
  );
}
